'use client'

import { useRouter } from 'next/navigation'
import { useCallback, type KeyboardEvent, type MouseEvent } from 'react'

export const useCardNavigation = (slug: string) => {
  const router = useRouter()

  const handleCardClick = useCallback(() => {
    router.push(`/product/${slug}`)
  }, [router, slug])

  const handleCardKeyDown = useCallback(
    (event: KeyboardEvent<HTMLElement>) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault()
        handleCardClick()
      }
    },
    [handleCardClick],
  )

  const stopCardNavigation = useCallback((event: MouseEvent<HTMLElement>) => {
    event.stopPropagation()
  }, [])

  return { handleCardClick, handleCardKeyDown, stopCardNavigation }
}
